import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Switch from '@material-ui/core/Switch';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import randomstring from 'uuid/v4';

import { NoImagenIcon } from '../../../../images/icons/WrapSvg';

class Machine extends React.Component {
    state = {
        maquinas: this.props.info,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.info && (props.info !== state.info || props.id !== state.id)) {
            state.id = props.id;
            state.maquinas = props.info ? props.info : [];
            return state;
        }
        return null;
    }

    handleChange = (index, value) => {
        const { maquinas } = this.state;
        maquinas[index].estado = value;
        this.props.onChange(maquinas[index].id, value !== 1);
        this.setState({ maquinas: maquinas });
    };

    render() {
        const { intl } = this.props;
        const { maquinas } = this.state;
        return (
            <Card className={'product_card margin_top_12'}>
                <CardContent>
                    <Grid container justify="center" className={'flex_grow_1'}>
                        <Grid item xs={12} className="">
                            <div className="barlow_medium c_dark_grey_blue text_align_left">
                                {intl.formatMessage({ id: 'production_machine_title' })}
                            </div>
                        </Grid>
                        <Grid item xs={12} className="margin_top_24">
                            <Grid container justify="center" className={'flex_grow_1'}>
                                <Grid
                                    item
                                    xs={3}
                                    className="shadow_down_only padding_4 center c_greyish_brown barlow_regular_small upper"
                                >
                                    <FormattedMessage id="production_machine_nombre" />
                                </Grid>
                                <Grid
                                    item
                                    xs={5}
                                    className="shadow_down_only padding_4 center c_greyish_brown barlow_regular_small upper"
                                >
                                    <FormattedMessage id="production_machine_alias" />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    className="shadow_down_only padding_4 center c_greyish_brown barlow_regular_small upper"
                                >
                                    <FormattedMessage id="production_machine_estado" />
                                </Grid>
                            </Grid>
                        </Grid>
                        {maquinas &&
                            maquinas.map((m, index) => (
                                <Grid key={randomstring()} item xs={12} className="margin_top_24">
                                    <Grid container justify="center" className={'flex_grow_1'}>
                                        <Grid
                                            item
                                            xs={1}
                                            className="shadow_down_only padding_4 center"
                                        >
                                            {m.fotoTipomaquina ? (
                                                <img
                                                    src={m.fotoTipomaquina}
                                                    alt={m.nombre}
                                                    style={{ width: 40 }}
                                                />
                                            ) : (
                                                <NoImagenIcon />
                                            )}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={2}
                                            className="shadow_down_only padding_4 center c_dark_grey_blue barlow_medium_subtitle"
                                        >
                                            {m.nomTipomaquina}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={5}
                                            className="shadow_down_only padding_4 center c_dark_grey_blue barlow_medium_subtitle"
                                        >
                                            {m.nombre}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={3}
                                            className="shadow_down_only padding_4 text_align_left"
                                        >
                                            {m.estado !== 1 ? (
                                                <div className="flex_full_row height100 c_dark_grey_blue barlow_medium_subtitle align_center">
                                                    <div className="production_dots bg_pea" />
                                                    <FormattedMessage id="production_machine_available" />
                                                </div>
                                            ) : (
                                                <div className="flex_full_row height100 c_dark_grey_blue barlow_medium_subtitle align_center">
                                                    <div className="production_dots bg_cool_grey" />
                                                    <FormattedMessage id="production_machine_disable" />
                                                </div>
                                            )}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={1}
                                            className="shadow_down_only padding_4 center"
                                        >
                                            <Switch
                                                checked={m.estado !== 1}
                                                onChange={(event) =>
                                                    this.handleChange(
                                                        index,
                                                        event.target.checked ? 3 : 1,
                                                    )
                                                }
                                                value="estado"
                                                color="primary"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                    </Grid>
                </CardContent>
            </Card>
        );
    }
}

Machine.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Machine);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/forecast/Machine.js